import { Attribute } from '../../Model/Attribute';

export interface FilterOptionsMap<T> {
    [key: string]: FilterOption<T>
}

interface AttributeOrValue {
    displayString: string
    numericValue?: number;
}

export class FilterOption<T> {
    public static fromAttribute<T>(attribute: Attribute): FilterOptionsMap<T> {
        const map: FilterOptionsMap<T> = {};
        if (!attribute.isMultiValue || !attribute.localeValueSet) {
            const option = FilterOption.fromAttributeValue<T>(attribute);
            map[option.name] = option;

            return map;
        } else {
            for (const attributeValue of attribute.localeValueSet.values) {
                const option = FilterOption.fromAttributeValue<T>(attributeValue);
                map[option.name] = option;
            }
        }

        return map;
    }

    public static fromAttributeValue<T>(attributeValue: AttributeOrValue): FilterOption<T> {
        const key = attributeValue.numericValue && !isNaN(attributeValue.numericValue)
            ? attributeValue.numericValue
            : attributeValue.displayString;

        return new FilterOption('' + key, attributeValue.displayString, true, false);
    }

    public readonly name: string;
    public readonly label: string;
    public readonly checked: boolean;
    public readonly value: T | string;
    protected _isAvailable: boolean;

    constructor(name: string, label: string, isAvailable: boolean, checked: boolean, value?: T | string) {
        this.checked = checked;
        this.label = label;
        this.name = name;
        this._isAvailable = isAvailable;
        this.value = value || name;
    }

    get isAvailable(): boolean {
        return this._isAvailable;
    }

    public clone(): FilterOption<T> {
        return new FilterOption(this.name, this.label, this._isAvailable, this.checked, this.value);
    }

    public withIsAvailable(flag: boolean): FilterOption<T> {
        const clone = this.clone();
        clone._isAvailable = flag;

        return clone;
    }
}
